var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found"},[_c('div',{staticClass:"not-found__text"},[_vm._v(_vm._s(_vm.text))]),_c('div',[_c('button',{on:{"click":_vm.goToIndex}},[_vm._v("Туда")])])])}
var staticRenderFns = []

export { render, staticRenderFns }